import {useCallback} from "react";
import {useNavigate} from "react-router";
import {startNavProgress} from "./navigation-progress";

export function useAppNavigate() {
    const navigate = useNavigate();

    return useCallback(
        (to, options) => {
            startNavProgress();
            return navigate(to, options);
        },
        [navigate]
    );
}
